
class Response {
  constructor(data, message, statusCode) {
    this.data = data;
    this.message = message || 'Success';
    this.statusCode = statusCode || 200;
  }

  toJSON() {
    return {
      data: this.data,
      message: this.message,
      statusCode: this.statusCode,
    };
  }

  static success(data, message = 'Success', statusCode = 200) {
    return new Response(data, message, statusCode);
  }

  static error(message = 'Error', statusCode = 500) {
    return new Response(null, message, statusCode);
  }

  static parse(response) {
    if (!response || typeof response !== 'object') {
      return Response.error('Invalid response format');
    }
    
    try {
      // If it's a string, try to parse it as JSON
      const data = typeof response === 'string' ? JSON.parse(response) : response;
      return new Response(data.data, data.message, data.statusCode);
    } catch (error) {
      return Response.error('Failed to parse response');
    }
  }
}

export default Response;